export default __webpack_public_path__ + "static/media/new-home.ccc1fe10.svg";